module.exports = __webpack_public_path__ + "img/5.93d482c2.png";